module.exports = __webpack_public_path__ + "assets/images/iconMicOFF.9963f3f3cf421bcc73ab60d2e90b021f.svg";